import { films } from "@/mocks/films";
import SectionHeading from "./SectionHeading";

const ranked = [...films].sort((a, b) => b.rating - a.rating);

const rankStyle = (i: number) => {
  if (i === 0) return "bg-accent-500 text-foreground-950";
  if (i === 1) return "bg-secondary-400 text-white";
  if (i === 2) return "bg-primary-700 text-white";
  return "bg-background-200 text-foreground-500";
};

export default function TopRank() {
  return (
    <section id="rank" className="section-pad scroll-mt-20 bg-background-100">
      <div className="container-x">
        <SectionHeading
          eyebrow="口碑热榜"
          title="本周口碑 Top 5"
          desc="综合专业媒体与大众观众的评价倾向整理出的站内高分推荐，是快速找到好片的可靠参考。"
        />
        <ol className="mt-8 grid gap-4">
          {ranked.map((f, i) => (
            <li key={f.id}>
              <a
                href="#new"
                className="group flex items-center gap-4 rounded-2xl border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-200 hover:bg-background-50 sm:gap-5 md:gap-7"
              >
                <span
                  className={
                    "flex h-11 w-11 shrink-0 items-center justify-center rounded-xl font-heading text-lg font-black " +
                    rankStyle(i)
                  }
                >
                  {i + 1}
                </span>
                <div className="relative hidden h-16 w-12 shrink-0 overflow-hidden rounded-lg sm:block">
                  <img src={f.poster} alt={f.title + " 海报"} className="h-full w-full object-cover object-top" />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                    <h3 className="font-heading text-base font-bold text-foreground-950 group-hover:text-primary-700 md:text-lg">
                      {f.title}
                    </h3>
                    <span className="text-xs text-foreground-500">{f.original}</span>
                  </div>
                  <p className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-0.5 text-xs text-foreground-600">
                    <span>{f.year}</span>
                    <i className="ri-checkbox-blank-circle-fill text-[4px]" aria-hidden="true"></i>
                    <span>{f.director}</span>
                    <span className="hidden sm:inline-flex sm:items-center sm:gap-1">
                      <i className="ri-checkbox-blank-circle-fill text-[4px]" aria-hidden="true"></i>
                      {f.genres.join(" · ")}
                    </span>
                  </p>
                </div>
                <div className="hidden w-40 shrink-0 items-center gap-3 md:flex">
                  <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-background-200">
                    <div
                      className="h-full rounded-full bg-gradient-to-r from-accent-500 to-primary-500"
                      style={{ width: `${Math.min(100, f.rating * 11)}%` }}
                    ></div>
                  </div>
                  <span className="w-8 text-right font-heading text-lg font-black text-accent-600">
                    {f.rating.toFixed(1)}
                  </span>
                </div>
                <i className="ri-arrow-right-s-line text-xl text-foreground-300 transition-colors group-hover:text-primary-500 md:hidden" aria-hidden="true"></i>
              </a>
            </li>
          ))}
        </ol>
        <p className="mt-5 flex items-center gap-2 text-xs text-foreground-500">
          <i className="ri-information-line" aria-hidden="true"></i>
          评分为吃瓜影院站内综合评价，仅作选片参考。点击条目可到新片速递浏览该片详情。
        </p>
      </div>
    </section>
  );
}